<template>
  <div class="flex flex-col items-center min-h-screen w-full bg-gray-100">
    <cabecera-gob-mx />

    <div class="rounded-lg shadow-lg w-5/6 min-w-sm max-w-md p-8 m-4 lg:my-12 flex-1 mx-auto shadow border bg-white">
      <div class="flex">
        <img v-if="url_image !== ''" :src="replaceURL(url_image)" alt="" />
      </div>
      <h1 class="text-center text-4xl font-bold my-5">
        {{ app_name }}
      </h1>

      <div class="w-full my-3">
        <form
          id="signUpForm"
          @submit.prevent="registerSubmit"
        >
          <h2 class="w-full text-2xl">
            Registro
          </h2>
          
          <div class="my-3">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
              for="name"
              >Nombre(s)</label
            >
            <input
              class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
              id="name"
              type="text"
              name="name"
              v-model="name"
            />
            <p v-if="errors.name" class="text-red-500 text-xs italic">
              Ingrese un nombre.
            </p>
          </div>

          <div class="my-3">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
              for="lastname"
              >Apellido(s)</label
            >
            <input
              class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
              id="lastname"
              type="text"
              name="lastname"
              v-model="lastname"
            />
            <p v-if="errors.name" class="text-red-500 text-xs italic">
              Ingrese un apellido.
            </p>
          </div>

          <div class="my-3">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
              for="email"
              >Correo electrónico</label
            >
            <input
              class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
              id="email"
              type="text"
              name="email"
              v-model="email"
            />
            <p v-if="errors.email" class="text-red-500 text-xs italic">
              Ingrese un correo electrónico.
            </p>
            <p v-if="errors.valid_email" class="text-red-500 text-xs italic">
              Ingrese un correo electrónico válido.
            </p>
          </div>
        
          <div class="my-3">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
              for="password"
              >Contraseña</label
            >
            <div class="relative">
              <input
                class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                id="password"
                :type="showPassword ? 'text' : 'password'"
                name="password"
                v-model="password"
              />
              <div
                class="absolute inset-y-0 right-0 pr-2 flex items-center cursor-pointer select-none"
                v-on:click="changePasswordVisibility()"
              >
                <svg
                  v-if="!showPassword"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6 fill-current"
                  viewBox="0 -960 960 960"
                >
                  <path
                    d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"
                  />
                </svg>
                <svg
                  v-else
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6 fill-current"
                  viewBox="0 -960 960 960"
                >
                  <path
                    d="m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z"
                  />
                </svg>
              </div>
            </div>
            <p v-if="errors.password" class="text-red-500 text-xs italic">
              La contraseña debe tener al menos 8 caracteres, al menos un
              número, al menos una minúscula, al menos una mayúsculas y al
              menos un caracter entre estos !@#$%^&*.
            </p>
            <p
              v-if="errors.valid_password"
              class="text-red-500 text-xs italic"
            >
              La contraseña no coincide.
            </p>
          </div>

          <div class="my-3">
            <label
              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
              for="password_again"
              >Repetir Contraseña</label
            >
            <div class="relative">
              <input
                class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                id="password_again"
                :type="showRepeatPassword ? 'text' : 'password'"
                name="password_again"
                v-model="password_again"
              />
              <div
                class="absolute inset-y-0 right-0 pr-2 flex items-center cursor-pointer select-none"
                v-on:click="changeRepeatPasswordVisibility()"
              >
                <svg
                  v-if="!showRepeatPassword"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6 fill-current"
                  viewBox="0 -960 960 960"
                >
                  <path
                    d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"
                  />
                </svg>
                <svg
                  v-else
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6 fill-current"
                  viewBox="0 -960 960 960"
                >
                  <path
                    d="m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z"
                  />
                </svg>
              </div>
            </div>
            <p
              v-if="errors.password_again"
              class="text-red-500 text-xs italic"
            >
              Ingrese una contraseña.
            </p>
          </div>

          <div class="flex justify-center">
            <vue-hcaptcha
              sitekey="cf7fc01e-97e2-492d-aa9a-2e0ecfcf269f"
              @verify="captchaVerify"
            ></vue-hcaptcha>
          </div>

          <div class="flex w-full justify-center pt-6">
            <btn-login
              class="px-4 py-2 text-center rounded-lg text-gray-100 tracking-wider uppercase font-bold disabled:opacity-75 disabled:cursor-default"
              type="submit"
              :disabled="!tokenIsValid"
              :colorS="color_secundario"
            >
              Registrar
            </btn-login>
          </div>

          <div class="flex w-full justify-center pt-2">
            <button
              v-on:click="goToLogin()"
              class="hover:underline p-1"
            >Iniciar sesión</button>
          </div>
        </form>
      </div>
    </div>

    <piedepagina-gob-mx />

    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          Usuario registrado correctamente
        </div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="redirectToLogin()"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">{{ errorMessage }}</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-cdmx-red"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

  </div>
</template>


<script>
import urlMixin from "@/mixins/urlMixin";
import AlertDialog from "./AlertDialog";

import VueHcaptcha from "@hcaptcha/vue-hcaptcha";


import { styled } from "@egoist/vue-emotion";
import CabeceraGobMx from "./CabeceraGobMx.vue";

import PiedepaginaGobMx from "./PiedepaginaGobMx.vue";


const BtnLogin = styled("button")`
  background-color: ${(props) => props.colorS};
  &:disabled {
    opacity: 0.75;
    cursor: default;
  }
`;

export default {
  mixins: [urlMixin],
  data() {
    return {
      name: "",
      lastname: "",
      email: "",
      password: "",
      password_again: "",
      showingSuccess: false,
      showingError: false,
      errorMessage: "",
      errors: {
        email: false,
        valid_email: false,
        password: false,
        password_again: false,
        valid_password: false,
      },
      tokenIsValid: false,
      showPassword: false,
      showRepeatPassword: false,
      url_image: "",
      color_principal: "",
      color_secundario: "",
      color_terciario: "",
      app_name: "",
    };
  },
  components: {
    AlertDialog,
    VueHcaptcha,
    BtnLogin,
    CabeceraGobMx,
    PiedepaginaGobMx,
  },
  computed: {},
  methods: {
    registerSubmit() {
      const form = document.getElementById("signUpForm");
      const formData = new FormData(form);
      const validForm = this.checkFormRegister(formData);
      if (validForm) {
        let user_info = {
          email: this.email.trim(),
          password: this.password,
          type: "registrante",
          name: this.name,
          lastname: this.lastname,
        };

        this.axios
          .post("apidev/users/", user_info)
          .then((data) => {
            this.showingSuccess = true;
          })
          .catch((err) => {
            // removed console log
            this.showingError = true;
          });
      }
    },
    checkFormRegister: function (data) {
      let re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      let paswordRexeg = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/;

      if (data.get("email") === "") {
        this.errors.email = true;
      } else {
        this.errors.email = false;
      }

      if (!re.test(data.get("email"))) {
        this.errors.valid_email = this.errors.email ? false : true;
      } else {
        this.errors.valid_email = false;
      }

      if (!paswordRexeg.test(data.get("password"))) {
        this.errors.password = true;
      } else {
        this.errors.password = false;
      }

      if (data.get("password_again") === "") {
        this.errors.password_again = true;
      } else {
        this.errors.password_again = false;
      }

      if (data.get("password") !== data.get("password_again")) {
        this.errors.valid_password = true;
        return false;
      } else {
        this.errors.valid_password = false;
      }

      if (data.get("name") === "") {
        this.errors.name = true;
      } else {
        this.errors.name = false;
      }

      if (data.get("last_name") === "") {
        this.errors.lastname = true;
      } else {
        this.errors.lastname = false;
      }

      if (
        this.errors.email ||
        this.errors.valid_email ||
        this.errors.name ||
        this.errors.lastname ||
        this.errors.password ||
        this.errors.password_again ||
        this.errors.valid_password
      ) {
        return false;
      }

      return true;
    },
    goToLogin() {
      this.$router.push({ path: "/login" });
    },
    redirectToLogin() {
      this.showingSuccess = false;
      this.goToLogin();
    },
    captchaVerify(token) {
      this.axios
        .post("apidev/users/register/verify", { token: token })
        .then((data) => {
          if (data.data.sucess === "ok") {
            this.tokenIsValid = true;
          } else {
            this.tokenIsValid = false;
          }
        })
        .catch((err) => {
          this.tokenIsValid = false;
          this.errorMessage = "Verificación fallida";
          this.showingError = true;
        });
    },
    changePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    changeRepeatPasswordVisibility() {
      this.showRepeatPassword = !this.showRepeatPassword;
    },
    fetchConfiguration() {
      this.axios
        .get("apidev/api/config/site")
        .then((response) => {
          let conf = response.data.config;
          this.url_image = conf.url_imagen;
          this.color_principal = conf.color_principal;
          this.color_secundario = conf.color_secundario;
          this.color_terciario = conf.color_terciario;
          this.app_name = conf.app_name;
        })
        .catch((error) => {
          // removed console log
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },

  },
  beforeMount() {
    this.fetchConfiguration();
  },
};
</script>
